import { Reducer } from 'redux';
import { NotificationActionTypes, NotificationState } from './types';

// 初期状態
export const initialState: NotificationState = {
  loading: false,
  data: {
    newRecordInsuranceTypes: [],
  },
};

const reducer: Reducer<NotificationState> = (
  state: NotificationState = initialState,
  action,
): NotificationState => {
  switch (action.type) {
    case NotificationActionTypes.FETCH_REQUEST: {
      return { ...state, loading: true };
    }
    case NotificationActionTypes.FETCH_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: {
          newRecordInsuranceTypes: action.payload.newRecordInsuranceTypes,
        },
      };
    }
    case NotificationActionTypes.FETCH_ERROR: {
      return { ...state, loading: false, errors: action.payload };
    }
    default:
      return state;
  }
};

export { reducer as notificationReducer };
